import { PropsWithChildren } from "react";

import { Typography, TypographyProps } from "@aircall/tractor";

import { InputChoiceContextValue } from "../../contexts/InputChoiceContext";
import { useInputChoice } from "../../contexts/useInputChoice";

import { InputChoiceLabelProps } from ".";

function pickColor({
  isSelected,
  isDisabled,
  color,
}: InputChoiceContextValue & {
  color: TypographyProps["color"];
}): TypographyProps["color"] {
  if (isDisabled) {
    return "text-disabled";
  }

  if (isSelected) {
    return "text-inverted";
  }

  return color;
}

export function InputChoiceLabel({
  color = "text-base",
  variant = "bodyMediumS",
  children,
  "data-test": dataTest = "input-choice-label",
  ...props
}: PropsWithChildren<InputChoiceLabelProps>) {
  const { isSelected, isDisabled } = useInputChoice();
  const pickedColor = pickColor({
    isSelected,
    isDisabled,
    color,
  });

  return (
    <Typography
      data-test={dataTest}
      color={pickedColor}
      variant={variant}
      {...props}
    >
      {children}
    </Typography>
  );
}
